module.exports = __webpack_public_path__ + "media/images/letter-495c2a632e5a4401dd27357bcceb89fc.png";